export const assets: any = {
};
